import { Component } from '@angular/core';
import { NavController, NavParams, Platform, AlertController, Events, MenuController, ModalController, PopoverController, ToastController, LoadingController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { HomePage } from '../home/home';
import { Geolocation } from '@ionic-native/geolocation';
import { ExitoPage } from '../exito/exito';
import { MonedaPage } from '../moneda/moneda';
import { DashboardPage } from '../dashboard/dashboard';
import { ClientesPage } from '../clientes/clientes';
import { FinishPage } from '../finish/finish';
import { DetailPage } from '../detail/detail';
import moment from 'moment'
import { SocialSharing } from '@ionic-native/social-sharing';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';

/**
 * Generated class for the CarritoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-pedido',
  templateUrl: 'pedido.html',
})
export class PedidoPage {
  carrito: any = []
  path:any = this.http.images
  id: any = ''
  cant:any = 0
  total:any = 0
  condiciones: any = []
  subtotal:any = 0
  iva:any = 0
  pedido: any = {}
  selectOptionsMetodo: any = {
    title: 'Método de pago',
  }
  exito: any
  loadModal: any
  moneda: any = 'USD'
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private plt: Platform,
    private file: File,
    private fileOpener: FileOpener,
    private socialSharing: SocialSharing,
    public loadingCtrl: LoadingController,
    public http: HttpProvider,
    public toastCtrl: ToastController,
    public popCtrl: PopoverController,
    public alertCtrl: AlertController,
    public events : Events,
    public menuCtrl: MenuController,
    private geolocation: Geolocation,
    public modal: ModalController
    ) {
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
    events.subscribe('moneda:update', ()=>{
      this.updateMoneda()
    })
    events.subscribe('pedido:update',()=>{
      this.update()  
    })
    this.exito = this.modal.create(ExitoPage)
    
    // if(window.localStorage.getItem('pedido')){
    //   this.pedido = JSON.parse(window.localStorage.getItem('pedido'))
    //   if(this.pedido.articulos){
    //     this.pedido.articulos.forEach(el=>{
    //       this.cant += el.cant
    //       this.subtotal += el.cant*el.precio.monto
    //       this.total += (el.cant*el.precio.monto) + (el.cant*el.precio.monto*el.iva)
    //       el.precio.monto = 0
    //     })
    //     this.pedido.vendedor = {
    //       co_ven: window.localStorage.getItem('co_ven'),
    //       co_us_in:'999',
    //       co_sucu_in:'999'
    //     }
    //     this.pedido.moneda = this.moneda
    //   }else{
    //     this.pedido.articulos = []
    //   }
    // }else{
    //   this.pedido.articulos = []
    // }
    // window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
    // this.events.publish('pedido:update')
  }

  enviarPDf(item) {
    this.ActivarLoading()
    let arts = [
      [
        { text: 'Descripción del producto', style: 'tableHeader' },
        { text: 'Precio', style: 'tableHeader' },
        { text: 'Cantidad', style: 'tableHeader' },
        { text: 'Total', style: 'tableHeader' }
      ]
    ]
    for (let i = 0; i < item.articulos.length; i++) {
      const el = item.articulos[i];
      arts.push([
        { text: el.art_des.trim(), style: 'tableRow' },
        { text: "$"+(el.precio.monto * el.equivalente).toFixed(2), style: 'tableRow' },
        { text: el.cant, style: 'tableRow' },
        { text: "$"+((el.precio.monto * el.equivalente) * el.cant).toFixed(2), style: 'tableRow' }
      ])
    }
    let bodyT = []
    bodyT.push([
      { text: '', style: 'tableHeader2' },
      { text: '', style: 'tableHeader2' },
      { text: 'Total', style: 'tableHeader2' },
      { text: '$'+this.total.toFixed(2), style: 'tableHeader2' }
    ])
    bodyT.push([
      { text: 'Fecha de órden: '+moment().format('DD-MM-YYYY'), style: 'tableRow2' },
      { text: '', style: 'tableRow2' },
      { text: '', style: 'tableRow2' },
      { text: '', style: 'tableRow2' },
    ])
    var docDefinition = {
      content: [
        
        { text: 'AVISO DE PEDIDO', style: 'header' },
        {
          image: 'data:image/jpeg;base64,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',
          width: 120,
          alignment: 'center',
        },
        { text: 'Pedido solicitado por:', style: 'text1' },
        { text: item.cliente.cli_des.trim(), style: 'text2' },
        {
          table: {
            headerRows: 1,
            widths: [200, '*', '*', '*'],
            body: arts
          }
        },
        {
          table: {
            headerRows: 1,
            widths: [200, '*', '*', '*'],
            body: bodyT,
          },
          layout: {
            hLineWidth: function(i, node) {
              return 0;
            },
            vLineWidth: function(i, node) {
              return 0;
            }
          }
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [ 0, 0, 0, 20 ]
        },
        text1: {
          fontSize: 12,
          bold: true,
          alignment: 'left',
          margin: [ 0, 10, 0, 0 ]
        },
        text2: {
          fontSize: 12,
          bold: true,
          alignment: 'left',
          margin: [ 0, 5, 0, 15 ]
        },
        tableHeader: {
          fillColor: '#012147',
          color: '#FFFFFF',
          bold: true
        },
        tableHeader2: {
            bold: true,
            margin: [ 0, 20, 0, 0 ]
        },
        tableRow: {
          fillColor: '#FFFFFF',
        },
        tableRow2: {
          fillColor: '#FFFFFF',
          bold: true
        },
      }
    }
    const pdfObj = pdfMake.createPdf(docDefinition);
    if (this.plt.is('cordova')) {
      pdfObj.getBuffer((buffer) => {
        var blob = new Blob([buffer], { type: 'application/pdf' });
        this.file.writeFile(this.file.dataDirectory, 'pedido.pdf', blob, { replace: true }).then(fileEntry => {
          this.DesactivarLoading()
          this.socialSharing.share("test", null, this.file.dataDirectory + 'pedido.pdf', null)
          // this.fileOpener.open(this.file.dataDirectory + 'myletter.pdf', 'application/pdf');
        }).catch(err=>{
          console.log(err)
          this.DesactivarLoading()
        })
      });
    } else {
      this.DesactivarLoading()
      pdfObj.download();
    }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  ionViewDidEnter() {
    this.update()
    // this.http.get('condicion').subscribe(
    //   (res:any)=>{
    //     this.ActivarLoading()
    //     if (res && res.length > 0) {
    //       this.condiciones = res
    //     }
    //   }, err => {
    //     this.DesactivarLoading()
    //     console.log(err)
    //   })
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  guardarDescrip() {
    window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
  }

  guardarCondicion(){
    window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  irDetail() {
    let acum = 0
    this.pedido.articulos.forEach(el=>{
      acum += parseFloat(el.cant)
    })
    let ped = {
      co_cli: this.pedido.cliente.co_cli,
      cliente: this.pedido.cliente.cli_des,
      articulos: acum,
      descripcion: this.pedido.descrip,
      moneda: this.pedido.moneda,
      renglones: this.pedido.articulos,
      total_bruto: this.subtotal,
      monto_imp: this.iva,
      total_neto: this.total
    }
    this.navCtrl.push(DetailPage, {pedido: ped})
  }

  enEspera() {
    this.alertCtrl.create({
      title: 'Atención',
      subTitle: '¿Seguro que desea colocar el pedido en espera?',
      cssClass:'alrt',
      buttons:[
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'btn'
        },
        {
          text:'Aceptar',
          cssClass: 'btnAceptar',
          handler:()=>{
            this.pedido.iva = this.iva
            this.pedido.subtotal = this.subtotal
            this.pedido.total = this.total
            let ped = []
            let pedidosE
            if (this.pedido.nro) {
              pedidosE = JSON.parse(window.localStorage.getItem('pedidoEspera'))
              for (let i = 0; i < pedidosE.length; i++) {
                let el = pedidosE[i];
                if (el.nro === this.pedido.nro) {
                  pedidosE.splice(i, 1)
                }
              }
              pedidosE.push(this.pedido)
              window.localStorage.setItem('pedidoEspera', JSON.stringify(pedidosE))
            } else if (window.localStorage.getItem('pedidoEspera')) {
              pedidosE = JSON.parse(window.localStorage.getItem('pedidoEspera'))
              if (pedidosE && pedidosE.length > 0) {
                pedidosE.sort(function(a, b) {
                  return b.nro - a.nro;
                });
                this.pedido.nro = parseInt(pedidosE[0].nro) + 1
                ped = pedidosE
                ped.push(this.pedido)
                window.localStorage.setItem('pedidoEspera', JSON.stringify(ped))
              } else {
                this.pedido.nro = 1
                ped.push(this.pedido)
                window.localStorage.setItem('pedidoEspera', JSON.stringify(ped))
              }
            } else {
              this.pedido.nro = 1
              ped.push(this.pedido)
              window.localStorage.setItem('pedidoEspera', JSON.stringify(ped))
            }
            this.pedido = null
            window.localStorage.removeItem('pedido')
            this.events.publish('pedido:update')
            this.navCtrl.setRoot(ClientesPage)
          }
        }
      ]
    }).present()
  }

  transform(value) {
    if(value){
      let val
      val = parseFloat(value)
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  update(coin: boolean = null){
    let ped = window.localStorage.getItem('pedido') ? JSON.parse(window.localStorage.getItem('pedido')) : null
    if(ped && ped.cliente && ped.cliente.co_ven){
      this.pedido = JSON.parse(window.localStorage.pedido)
      this.pedido.co_cond = this.pedido.cliente.cond_pag.trim()
      this.pedido.moneda = 'USD' 
      if(this.pedido.articulos){
        this.cant = 0
        this.subtotal = 0
        this.iva = 0
        this.total = 0
        this.pedido.articulos.forEach(el=>{ 
          el.precio = el.precio
          this.cant += parseFloat(el.cant)
          let montoOriginal = el.precio.monto / (1 + el.iva / 100);
          this.subtotal += el.cant*montoOriginal * el.equivalente
          this.iva += el.cant*montoOriginal*(el.iva / 100) * el.equivalente
        })
        this.total += this.subtotal + this.iva
        if (!window.localStorage.super) {
          this.pedido.vendedor = {
            co_ven: window.localStorage.getItem('co_ven'),
            ven_des: window.localStorage.getItem('nombre'),
            co_us_in:'999',
            co_sucu_in:'999'
          }
        } else {
          this.http.get('vendedor/cod/' + this.pedido.cliente.co_ven).subscribe((res:any) => {
            this.pedido = JSON.parse(window.localStorage.pedido)
            this.pedido.vendedor = {
              co_ven: this.pedido.cliente.co_ven,
              ven_des: res.ven_des,
              co_us_in:'999',
              co_sucu_in:'999'
            }
            window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
          })
        }
      }else{
        this.pedido.articulos = []
        this.total = 0
        this.iva = 0
        this.subtotal = 0
      }
    }else{
      this.pedido = {}
      this.pedido.articulos = []
      this.total = 0
      this.iva = 0
      this.subtotal = 0
    }
    this.pedido.tasa = window.localStorage.cambio
    // this.condiciones = JSON.parse(window.localStorage.getItem('condiciones'))
    // if ((!this.pedido || !this.pedido.co_cond) && this.condiciones && this.condiciones.length > 0) {
    //   this.pedido.co_cond = this.condiciones[0].co_cond
    // }
    window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
  }

  abrirmenu(){
    this.menuCtrl.open();
  }
  eliminar(index){
    this.carrito.splice(index,1)
    window.localStorage.setItem('carrito',JSON.stringify(this.carrito))
    this.update()
  }
  home(){
    this.navCtrl.setRoot(HomePage)
  }

  actMonto(index) {
    if(this.pedido.articulos[index].cant && this.pedido.articulos[index].cant > (parseFloat(this.pedido.articulos[index].stockP) * parseFloat(this.pedido.articulos[index].equivalente))){
      this.pedido.articulos[index].cant = (parseFloat(this.pedido.articulos[index].stockP) * parseFloat(this.pedido.articulos[index].equivalente))
      window.localStorage.setItem('pedido',JSON.stringify(this.pedido))
      this.events.publish('pedido:update')
    }
  }

  agregar(index){
    if(this.pedido.articulos[index].cant < (parseFloat(this.pedido.articulos[index].stockP) * parseFloat(this.pedido.articulos[index].equivalente))){
      this.pedido.articulos[index].cant++
      window.localStorage.setItem('pedido',JSON.stringify(this.pedido))
    }
    this.events.publish('pedido:update')
  }

  clear(){
    this.alertCtrl.create({
      title:'Atención',
      subTitle:'¿Esá seguro que desea eliminar este pedido?',
      buttons:[
        {
          text:'Cancelar',
          cssClass:'btn'
        },
        {
          text:'Aceptar',
          cssClass:'btnAceptar',
          handler:()=>{
            this.pedido = {}
            window.localStorage.setItem('pedido',JSON.stringify(this.pedido));
            this.events.publish('pedido:update')
            this.navCtrl.setRoot(ClientesPage)
          }
        }
      ]
    }).present()
  }

  eliminarProd(i) {
    this.pedido.articulos.splice(i, 1)
    if (this.pedido.articulos.length === 0) {
      window.localStorage.setItem('pedido',JSON.stringify(this.pedido))
      this.navCtrl.pop()
    } else {
      window.localStorage.setItem('pedido',JSON.stringify(this.pedido))
      this.events.publish('pedido:update')
    }
  }

  procesar(){
    this.ActivarLoading()
    if(window.localStorage.getItem('network') === '1'){
      if(this.pedido.articulos && this.pedido.articulos.length > 0){
        this.pedido.iva = this.iva
        this.pedido.subtotal = this.subtotal
        this.pedido.total = this.total
        this.http.post('pedido',this.pedido).subscribe(
          (res:any)=>{
            this.DesactivarLoading()
            if(res.error){
              this.alertCtrl.create({
                title: 'Error',
                subTitle:'Ha ocurrido un error',
                buttons:[
                  {
                    text:'Aceptar',
                    cssClass:'btnAceptar',
                  }
                ]
              }).present()
            }else{
              if (!window.localStorage.super) {
                let options = {
                  enableHighAccuracy: true
                }
                this.geolocation.getCurrentPosition(options).then((resp) => {
                  let info = {
                    co_ven: window.localStorage.getItem('co_ven'),
                    coordenadas: {
                      lat: resp.coords.latitude,
                      lng: resp.coords.longitude
                    },
                    doc_num: res.doc_num,
                    pedido: res
                  }
                  this.http.post('ubicacionPedido', info).subscribe((res:any)=> {
                    console.log(res)
                  })
                 })
              }
              let ped = JSON.parse(window.localStorage.getItem('pedidoEspera'))
              if (ped && ped.length > 0) {
                let ped2 = ped.filter(el=>{
                  return el.nro !== this.pedido.nro
                })
                window.localStorage.setItem('pedidoEspera', JSON.stringify(ped2))
              }
              let info = res
              info.iva = this.iva
              info.subtotal = this.subtotal
              info.total = this.total
              // this.modal.create(ExitoPage,{pedido:res, info: this.pedido}).present()
              this.navCtrl.push(FinishPage,{pedido: res.doc_num, mostrar: "N"})
              this.pedido = {}
              window.localStorage.removeItem('pedido')
              this.events.publish('pedido:update')
            }
          },
          error=>{
            this.DesactivarLoading()
            this.toastCtrl.create({
              duration: 4000,
              message:'Ha ocurrido un error, por favor intente de nuevo.'
            }).present()
          }
        )
      }
    }else{
      let pedidos = JSON.parse(localStorage.getItem('pedidos'));
      if(!pedidos){
        pedidos = []
        this.pedido.identificador = 1
      } else {
        let num = 0
        pedidos.forEach((el, index)=> {
          if (index == 0) {
            num = parseFloat(el.identificador)
          } else {
            if (parseFloat(el.identificador) > num) num = parseFloat(el.identificador)
          }
        })
        this.pedido.identificador = num + 1
      }
      this.pedido.respaldado = false
      this.pedido.iva = this.iva
      this.pedido.subtotal = this.subtotal
      this.pedido.total = this.total
      this.pedido.doc_num = 'S/N'
      this.pedido.status = '3'
      let total = 0
      for(let i = 0; i< this.pedido.articulos.length;i++){
        total += (this.pedido.articulos[i].cant * this.pedido.articulos[i].equivalente)*this.pedido.articulos[i].precio.monto
      }
      this.pedido.total_neto = total + parseFloat(this.pedido.iva)
      pedidos.push(this.pedido)
      window.localStorage.setItem('pedidos', JSON.stringify(pedidos));
      this.pedido = {}
      window.localStorage.removeItem('pedido')
      this.update()
      this.DesactivarLoading()
      this.alertCtrl.create({
        title: 'Sin Conexion',
        subTitle:'No hay conexion a internet, el pedido se guardara en memoria, cuando posea conexión a internet el pedido se creará automaticamente.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
              this.navCtrl.setRoot(DashboardPage)
            }
          }
        ]
      }).present()
    }
  }

  restar(index){
    if(this.pedido.articulos[index].cant<2){
      this.pedido.articulos.splice(index,1)
    }else{
      this.pedido.articulos[index].cant--
    }
    window.localStorage.setItem('pedido',JSON.stringify(this.pedido))
    this.events.publish('pedido:update')
  }

}



// WEBPACK FOOTER //
// ./src/pages/pedido/pedido.ts